<template>
  <div v-a11y-tab>
    <a-select
      show-search
      option-filter-prop="children"
      :placeholder="$t('month')"
      :filter-option="filterOption"
      :value="months[value]"
      @change="handleChange"
      class="month-picker"
    >
      <a-select-option v-for="(month, index) in months" :key="month" :value="index">{{ month }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
  },
  data() {
    return {
      months: [
        this.$t('jan'),
        this.$t('feb'),
        this.$t('mar'),
        this.$t('apr'),
        this.$t('may'),
        this.$t('jun'),
        this.$t('jul'),
        this.$t('aug'),
        this.$t('sep'),
        this.$t('oct'),
        this.$t('nov'),
        this.$t('dec'),
      ],
    };
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(month) {
      this.$emit('input', month);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.month-picker {
  width: 165px;
}

@media (max-width: $page-mobile-large-breakpoint) {
  .month-picker {
    width: 140px;
  }
}
</style>
